export function handleBoardResult(result) {
  const data = result.data
  let d: any
  if (data.data) {
    d = JSON.parse(data.data)
    let layouts = d["layouts"]
    for (const key in layouts) {
      if (layouts.hasOwnProperty(key)) {
        let layout = layouts[key]
        if (key === "lg" || key === "xxs") {
          layout = layout.map((item, i) => {
            item.i = d.charts[i]["id"]
            if (typeof item.y !== "number") {
              item.y = Infinity
            }
            return item
          })
        } else {
          // 移除老旧布局(md, sm, xs)
          delete layouts[key]
        }
      }
    }
  }
  return { board: data, data: d }
}
export function handleChartResult(result) {
  const data = result.data || {}
  if (data.y && data.y.length > 0) {
    data.y.forEach(count => {
      if (count.data && count.data.length > 0) {
        if (count.aggregator === "avg") {
          let data = count.data || []
          data.forEach((v, i) => {
            data[i] = v >= 100 ? Math.round(v) : Math.round(v * 100) / 100
          })
        }
      }
    })
  }

  if (data.layers && data.layers.length > 0) {
    // 平均值保留2位小数
    data.layers.forEach(layer => {
      layer.y &&
        layer.y.forEach(y => {
          if (y.aggregator === "avg") {
            y.data = y.data.map(v => {
              return Math.round(v * 100) / 100
            })
          }
        })
    })
  }
  return data
}

export function handleAreasResult(result) {
  const { data = [] } = result
  const codeMap = {}
  data.forEach(pro => {
    pro.geo = formatAreaFeatures(pro)
    pro.level = 1
    codeMap[pro.code] = pro
    pro.sub_areas &&
      pro.sub_areas.forEach(city => {
        city.level = 2
        codeMap[city.code] = city
        city.geo = formatAreaFeatures(city)
        city.sub_areas &&
          city.sub_areas.forEach(district => {
            codeMap[district.code] = district
            district.geo = formatAreaFeatures(district)
            district.level = 3
          })
      })
  })
  return { tree: data, map: codeMap }
}

export function formatAreaFeatures(area) {
  let { code, lat, lng, name, polygon } = area
  return {
    type: "Feature",
    properties: {
      code,
      name,
      lng: parseFloat(lng),
      lat: parseFloat(lat),
    },
    geometry: {
      type: "MultiPolygon",
      coordinates: polygon || [[[]]],
    },
  }
}
